
export default {
  'formActions': {
    'addPlaceInput': 'Ajouter un champ de lieu',
    'clearRoute': 'Effacer l\'itinéraire',
    'reverseRoute': 'Inverser le route',
    'roundTrip': 'Route circulaire',
    'toggleRoundTrip': 'Basculer route circulaire'
  },
}
